import { render } from "./NotesItem.vue?vue&type=template&id=7d319a59"
import script from "./NotesItem.vue?vue&type=script&lang=js"
export * from "./NotesItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__